export default class TurnoAperturaRequest 
{

    aperturaTurnoId!:number;
    plantaId!: number;
    wipInicial!: number;
    wipFinal!: number;
    usuarioId!: string;
    turnoId!: number;
}